import React from 'react';
export var InlineLoader = function (_a) {
    var isLoading = _a.isLoading, _b = _a.className, className = _b === void 0 ? '' : _b, width = _a.width, _c = _a.linear, linear = _c === void 0 ? true : _c;
    return (React.createElement(React.Fragment, null, isLoading && (linear ?
        React.createElement("div", { className: "inline-loader " + className + " " + (linear ? 'linear' : '') },
            React.createElement("div", { className: "inline-loader-value" })) :
        React.createElement("div", { className: "lds-ring " + className },
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null)))));
};
